<template>
  <div class="wrapper">
    <el-card shadow="never" style="margin-bottom: 10px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'techPersonnelList' }">特派员信息列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    
    <el-form ref="techPersonnelForm" :model="techPersonnelForm" label-width="120px" :rules="rules" :size="defaultFormItemSize">
      <el-row>
        <el-col :span="24">
          <el-form-item label="专家姓名" prop="expertName">
            <el-input v-model="techPersonnelForm.expertName" placeholder="请输入专家姓名" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="服务单位" prop="serviceUnit">
            <el-input v-model="techPersonnelForm.serviceUnit" placeholder="请输入服务单位" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作单位" prop="workUnit">
            <el-input v-model="techPersonnelForm.workUnit" placeholder="请输入工作单位" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="服务领域" prop="serviceField">
            <el-input v-model="techPersonnelForm.serviceField" placeholder="请输入服务领域" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="contactInfo">
            <el-input v-model="techPersonnelForm.contactInfo" placeholder="请输入联系方式" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="乡镇、街道" prop="townStreet">
            <el-input v-model="techPersonnelForm.townStreet" placeholder="请输入乡镇、街道" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="行政村（社区）" prop="administrativeVillage">
            <el-input v-model="techPersonnelForm.administrativeVillage" placeholder="请输入行政村（社区）" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="科技特派员类型" prop="personnelType">
            <el-input v-model="techPersonnelForm.personnelType" placeholder="请输入科技特派员类型" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职级" prop="jobGrade">
            <el-input v-model="techPersonnelForm.jobGrade" placeholder="请输入职级" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="图片">
            <el-upload
              class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
              :action="getUploadActionUrl('/admin/app/techPersonnel/upload')"
              :data="{fieldName: 'imageUrl', asImage: true}"
              :on-success="onImageUrlUploadSuccess"
              :on-remove="onImageUrlRemoveFile"
              :on-error="onUploadError"
              :show-file-list="true"
              :on-preview="handlePreview"
              :limit="1"
              :on-exceed="onUploadLimit"
              :file-list="fileList"
              list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input v-model="techPersonnelForm.remark" placeholder="请输入备注" type="textarea" :rows="3"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    
    <div class="form-button-group">
      <el-button type="primary" :size="defaultFormItemSize" @click="submitForm()" :loading="isLoading">{{ isAddMode ? '新增' : '保存' }}</el-button>
      <el-button type="default" :size="defaultFormItemSize" @click="onCancelClick()">取消</el-button>
    </div>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
  </div>
</template>

<script>
import { TechPersonnelController } from '@/api';
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';

export default {
  name: 'techPersonnelForm',
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  props: {
    closeVisible: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      // 本地存储id和mode，避免直接修改props
      localId: '',
      localMode: 'add',
      techPersonnelForm: {
        id: undefined,
        expertName: undefined,
        serviceUnit: undefined,
        workUnit: undefined,
        serviceField: undefined,
        contactInfo: undefined,
        townStreet: undefined,
        administrativeVillage: undefined,
        personnelType: undefined,
        jobGrade: undefined,
        remark: undefined,
        imageUrl: undefined
      },
      rules: {
        expertName: [
          { required: true, message: '请输入专家姓名', trigger: 'blur' }
        ]
      },
      fileList: [],
      imgViewerVisible: false,
      imgList: [],
      isLoading: false,
      defaultFormItemSize: 'small'
    };
  },
  computed: {
    isAddMode () {
      return this.localMode === 'add';
    },
    title () {
      return this.isAddMode ? '新增特派员信息' : '编辑特派员信息';
    }
  },
  mounted () {
    // 获取路由参数
    this.initFromRoute();
  },
  // 监听路由变化，处理参数更新
  watch: {
    '$route.query': {
      handler () {
        this.initFromRoute();
      },
      deep: true
    }
  },
  // 路由更新时的处理（适用于组件复用的情况）
  beforeRouteUpdate (to, from, next) {
    this.initFromRoute();
    next();
  },
  methods: {
    // 从路由初始化数据
    initFromRoute () {
      // 获取路由参数
      const query = this.$route.query;
      if (query.id) {
        // 重置状态，避免数据缓存
        this.resetForm();
        this.localId = query.id;
        this.localMode = 'update';
        this.loadData();
      } else if (query.mode === 'add') {
        // 重置状态，确保是新增模式
        this.resetForm();
        this.localMode = 'add';
      }
    },
    // 重置表单状态
    resetForm () {
      // 重置表单数据
      this.techPersonnelForm = {
        id: undefined,
        expertName: undefined,
        serviceUnit: undefined,
        workUnit: undefined,
        serviceField: undefined,
        contactInfo: undefined,
        townStreet: undefined,
        administrativeVillage: undefined,
        personnelType: undefined,
        jobGrade: undefined,
        remark: undefined,
        imageUrl: undefined
      };
      // 重置文件列表
      this.fileList = [];
      // 重置加载状态
      this.isLoading = false;
    },
    loadData () {
      this.isLoading = true;
      console.log('加载数据，ID:', this.localId);
      TechPersonnelController.view(this, { id: this.localId }).then(res => {
        console.log('加载数据成功:', res.data);
        this.techPersonnelForm = res.data;
        // 解析图片数据
        if (res.data.imageUrl) {
          let imageUrlDownloadParams = {
            id: res.data.id,
            fieldName: 'imageUrl',
            asImage: true
          };
          this.fileList = this.parseUploadData(res.data.imageUrl, imageUrlDownloadParams);
        }
      }).catch(e => {
        console.error('加载数据失败:', e);
        this.$message.error('加载数据失败');
      }).finally(() => {
        this.isLoading = false;
      });
    },
    handlePreview (file) {
      this.imgViewerVisible = true;
      this.imgList = [];
      this.imgList.push(file.url);
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    onImageUrlUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.fileList = fileList;
        this.techPersonnelForm.imageUrl = this.fileListToJson(fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    onImageUrlRemoveFile (file, fileList) {
      this.fileList = fileList;
      this.techPersonnelForm.imageUrl = this.fileListToJson(fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('上传失败');
    },
    onUploadLimit (file, fileList) {
      this.$message.error('最多只能上传1个文件');
    },
    submitForm () {
      this.$refs.techPersonnelForm.validate(valid => {
        if (valid) {
          this.isLoading = true;
          let params = {
            techPersonnelDto: {
              // 无论是新增还是编辑模式，都明确列出需要提交的字段
              id: this.techPersonnelForm.id,
              expertName: this.techPersonnelForm.expertName,
              serviceUnit: this.techPersonnelForm.serviceUnit,
              workUnit: this.techPersonnelForm.workUnit,
              serviceField: this.techPersonnelForm.serviceField,
              contactInfo: this.techPersonnelForm.contactInfo,
              townStreet: this.techPersonnelForm.townStreet,
              administrativeVillage: this.techPersonnelForm.administrativeVillage,
              personnelType: this.techPersonnelForm.personnelType,
              jobGrade: this.techPersonnelForm.jobGrade,
              remark: this.techPersonnelForm.remark,
              imageUrl: this.techPersonnelForm.imageUrl
            }
          };
          console.log('提交参数:', params);

          const savePromise = this.isAddMode
            ? TechPersonnelController.add(this, params)
            : TechPersonnelController.update(this, params);

          savePromise.then(res => {
            this.$message.success(this.isAddMode ? '新增成功' : '更新成功');
            this.$emit('success');
            this.close();
          }).catch(e => {
            this.$message.error(e.msg || (this.isAddMode ? '新增失败' : '更新失败'));
          }).finally(() => {
            this.isLoading = false;
          });
        } else {
          return false;
        }
      });
    },
    close () {
      if (this.closeVisible === 1) {
        this.$router.go(-1);
      } else {
        this.$emit('close');
      }
    },
    onCancelClick () {
      // 返回特派员信息列表页面
      this.$router.push({ name: 'techPersonnelList' });
    }
  }
};
</script>

<style scoped>
.wrapper {
  padding: 20px;
}

.form-button-group {
  margin-top: 20px;
  text-align: center;
}
</style>
